// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
// import routes
import routers from './routers';
import ConditionRouter from './routers/ConditionRouter';
// import lib
import { isLogin } from './lib/auth';
// import reducers
import { setAuthAccount } from './redux/reducers/auth';
// import store
import store from './redux/store';
// css
import 'react-toastify/dist/ReactToastify.css';

const App = () => {

    // const dispatch = useDispatch()
    /* if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-900">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
            </div>
        );
    } */

    useEffect(() => {
        const { status, decoded } = isLogin();
        if (status) {
            store.dispatch(setAuthAccount(decoded));
        }
    }, []);

    return (
        <Provider store={store}>
            <Router basename='/'>
                <ToastContainer />
                <Routes>
                    {
                        routers && routers.length > 0 && routers.map((item, key) => {
                            return (
                                <Route key={key} exact={true} path={item.path} element={
                                    <ConditionRouter type={item.type} isSideMenu={item.isSideMenu}>
                                        <item.component />
                                    </ConditionRouter>
                                } />
                            )
                        })
                    }
                </Routes>
            </Router>
        </Provider>
    );
}

export default App;